import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ModalTransition } from '@atlaskit/modal-dialog';
import {
  ShowFn,
  AppearanceTypes,
  Id, noop, ModalsOptions,
  ModalOptions,
  RemoveFn,
  UpdateFn, ModalProps,
} from './types';

import DeleteModal from './DeleteModal';
import FormModal from './FormModal';

type Context = {
  show: ShowFn;
  hide: RemoveFn;
  hideAll: () => void;
  update: UpdateFn;
};

export const ModalContext = React.createContext<Context | null>(null);
const { Consumer, Provider } = ModalContext;

const modalMap = {
  'delete': DeleteModal,
  'form': FormModal,
  'default': DeleteModal,
};

export const ModalProvider: React.FC = ({ children }) => {

  const [modals, setModals] = useState<ModalProps[]>([]);

  const hide = useCallback((id: Id) => {
    setModals(modals.filter(modal => modal.id !== id));
  },[]);

  const hideAll = useCallback(() => {
    setModals([]);
  },[]);

  const update = useCallback((id: Id, options: ModalOptions) => {
    alert('Not implemented yet');
  },[]);

  // const handleOnDismiss = useCallback((id: Id, cb: Callback = noop) => () => {
  //     cb(id);
  //     hide(id);
  //   },[hide]);

  const show = useCallback((options: ModalOptions) => {
    const id =  options.id || uuidv4();
    const modal: ModalProps = {
      ...options,
      id,
      onClose: () => hide(id),
    };
    setModals([...modals, modal]);
    return id;
  },[]);

  const value = useMemo(() => ({
    show,
    hide,
    hideAll,
    update,
  }),[]);

  return (
    <ModalContext.Provider
      value={value}
    >
      {children}
      <ModalTransition>
        {modals.map(modal => {
          const {title, content, actions, type = 'default', id} = modal;
          const ModalComponent = modalMap[type] || modalMap.default;
          // @ts-ignore
          return (<ModalComponent key={id} {...modal}/>);
        })}
      </ModalTransition>
    </ModalContext.Provider>
  );
};
